export default __webpack_public_path__ + "static/media/Fuchs.7698aae4.png";